import React from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";

import styles from "assets/jss/material-dashboard-pro-react/views/errorPageStyles";

const useStyles = makeStyles(styles);

export default function ErrorPage() {
  const classes = useStyles();
  return (
    <div className={classes.contentCenter}>
      <GridContainer>
        <GridItem md={12}>
          <h1 className={classes.title}>\o/</h1>
          <h2 className={classes.subTitle}>Plataforma em atualização :)</h2>
          <h4 className={classes.description} style={{ color: '#FFFFFF' }}>
            Tente acessar novamente em alguns minutos. Estamos implementando melhorias para melhor produtividade no seu dia a dia.
          </h4>
        </GridItem>
      </GridContainer>
    </div>
  );
}
